'use client'

import type { ReactNode } from 'react'
import { AuthProvider } from '@/auth/AuthContext'

/** Who is signed in, available to every screen. */
export default function Providers({ children }: { children: ReactNode }) {
  return <AuthProvider>{children}</AuthProvider>
}
